import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import ManualProgress from '../commoncomponents/manualProgress';

class DepotTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {

  }

  calculatePercentage = (denominator, numerator) => {
    let value = isNaN(Math.round((parseInt(numerator) / parseInt(denominator)) * 100)) ? 0 : Math.round((parseInt(numerator) / parseInt(denominator)) * 100)
    return value;
  }

  render() {
    const barStyle = {
      width: `112px`,
    }
    return (

      <Table responsive striped>
        <thead>
          <tr>

            <th>Name</th>
            <th>Total Fleet</th>
            <th>Active</th>
            <th>Active Reporting</th>
            <th>Not responding</th>
            <th>In Depot</th>
            <th>Awaiting Install</th>
            <th>Uninstalled</th>
            <th>Maintenance</th>
            <th>Power Cut</th>

            <th>Duress</th>

          </tr>
        </thead>
        <tbody>
          {this.props.depotList.map((depot, index) => {
            return (
              <tr>
                <td>{depot.depotName}</td>
                <td>{depot.totalAsset}</td>
                <td>
                  {depot.active}
                </td>
                <td style={barStyle}>
                  <ManualProgress
                    value={this.calculatePercentage(depot.active, depot.activeReporting)}
                    color="#28A744"
                    valueString={`${depot.activeReporting}(${this.calculatePercentage(depot.active, depot.activeReporting)}%)`}
                  />
                </td>
                <td style={barStyle}>
                  <ManualProgress
                    value={this.calculatePercentage(depot.active, (parseInt(depot.active) - parseInt(depot.activeReporting)))}
                    color="#dc3545"
                    valueString={`${(parseInt(depot.active) - parseInt(depot.activeReporting))}(${this.calculatePercentage(depot.active, (parseInt(depot.active) - parseInt(depot.activeReporting)))}%)`}
                  />

                </td>
                <td style={barStyle}>
                  <ManualProgress
                    value={this.calculatePercentage(depot.active, depot.inDepot)}
                    color="#17A2B8"
                    valueString={`${depot.inDepot}(${this.calculatePercentage(depot.active, depot.inDepot)}%)`}
                  />
                </td>
                <td style={barStyle}>
                  <ManualProgress
                    value={this.calculatePercentage(depot.totalAsset, depot.awaitinginstall)}
                    color="#343A40"
                    valueString={`${depot.awaitinginstall}(${this.calculatePercentage(depot.totalAsset, depot.awaitinginstall)}%)`}
                  />
                </td>
                <td style={barStyle}>
                  <ManualProgress
                    value={this.calculatePercentage(depot.totalAsset, depot.uninstalled)}
                    color="#007BFF"
                    valueString={`${depot.uninstalled}(${this.calculatePercentage(depot.totalAsset, depot.uninstalled)}%)`}
                  />
                </td>
                <td style={barStyle}>
                  <ManualProgress
                    value={this.calculatePercentage(depot.totalAsset, depot.maintenance)}
                    color="ffc107"
                    valueString={`${depot.maintenance}(${this.calculatePercentage(depot.totalAsset, depot.maintenance)}%)`}
                  />
                </td>
                <td>{depot.powerCut}</td>
                <td>{depot.duress}</td>
              </tr>

            )
          })}

        </tbody>

      </Table>

    );
  }

}

export default DepotTable;
